import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DoNotDisturbRoundedIcon from "@mui/icons-material/DoNotDisturbRounded";
import { useEffect, useState } from "react";
import {
  ProfileDocument,
  ProfileDocumentStatus,
  ProfileDocumentType,
  ProfileDocumentTypeLabel,
} from "../../common/ProfileDocument";
import convertDateToString from "../../util/ConvertDateToString";
import checkDocumentExpiration from "../../util/checkDocumentExpiration";

interface MyDocumentsProps {
  profileId: number;
  myDocuments: ProfileDocument[];
}

const MyDocuments = (props: MyDocumentsProps) => {
  const [profileDocuments, setProfileDocuments] = useState<ProfileDocument[]>(
    []
  );

  let missingDocumentTypes: ProfileDocumentType[] = [
    ProfileDocumentType.MMC,
    ProfileDocumentType.TWIC,
    ProfileDocumentType.MEDICAL_CERT,
    ProfileDocumentType.PASSPORT,
  ];
  profileDocuments.forEach((doc) => {
    if (
      doc.type === ProfileDocumentType.MMC ||
      doc.type === ProfileDocumentType.TWIC ||
      doc.type === ProfileDocumentType.MEDICAL_CERT ||
      doc.type === ProfileDocumentType.PASSPORT
    ) {
      missingDocumentTypes.splice(
        missingDocumentTypes.findIndex((item) => item === doc.type),
        1
      );
    }
  });

  useEffect(() => {
    let res: any = JSON.parse(JSON.stringify(props.myDocuments));
    setProfileDocuments(
      res.map((doc: any) => {
        // convert null values to empty string
        Object.keys(doc).forEach(
          (key) => (doc[key] = doc[key] === null ? "" : doc[key])
        );
        // convert dates to string
        if (doc["issueDate"] !== undefined && doc["issueDate"] !== "") {
          doc["issueDate"] = convertDateToString(new Date(doc["issueDate"]));
        }
        if (
          doc["expirationDate"] !== undefined &&
          doc["expirationDate"] !== ""
        ) {
          doc["expirationDate"] = convertDateToString(
            new Date(doc["expirationDate"])
          );
        }
        return doc as ProfileDocument;
      })
    );
  }, [props.myDocuments]);

  return (
    <TableContainer>
      <Table className="documents-table">
        <TableHead>
          <TableRow>
            <TableCell>TYPE</TableCell>
            <TableCell>EXPIRING</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {profileDocuments.map((doc) => (
            <TableRow key={doc.id}>
              <TableCell>{ProfileDocumentTypeLabel[doc.type]}</TableCell>
              <TableCell>
                {checkDocumentExpiration(doc) ===
                  ProfileDocumentStatus.EXPIRED && (
                  <span className="flex my-0 gc-1 align-items-center">
                    <ErrorOutlineRoundedIcon color="error" /> Expired
                  </span>
                )}
                {checkDocumentExpiration(doc) ===
                  ProfileDocumentStatus.EXPIRING_SOON && (
                  <span className="flex my-0 gc-1 align-items-center">
                    <WarningAmberRoundedIcon color="warning" /> Expiring Soon
                  </span>
                )}
                {checkDocumentExpiration(doc) ===
                  ProfileDocumentStatus.UPLOADED && (
                  <span className="flex my-0 gc-1 align-items-center">
                    <CheckCircleOutlineRoundedIcon color="success" /> Uploaded
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
          {!!missingDocumentTypes &&
            missingDocumentTypes.length > 0 &&
            missingDocumentTypes.map((docType) => (
              <TableRow key={docType}>
                <TableCell>{ProfileDocumentTypeLabel[docType]}</TableCell>
                <TableCell>
                  <span className="flex my-0 gc-1 align-items-center">
                    <DoNotDisturbRoundedIcon color="error" /> Not Uploaded
                  </span>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MyDocuments;
